import { ISeoLinksTab } from '../../types/seoTabsLinks';

export function seoTabsLinksReducer(state: ISeoLinksTab[] | null = null): ISeoLinksTab[] | null {
  return state;
}
